import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { TextureLoader } from 'three';

export class LoaderController {
	gltfLoader: GLTFLoader;
	textureLoader: TextureLoader;

	/**
	 * Constructor
	 * */
	constructor() {
		this.gltfLoader = new GLTFLoader();
		this.textureLoader = new THREE.TextureLoader();
	}

	/**
	 * Loads a model, returning an awaitable promise
	 * */
	loadModelFromAsset(path: string) {
		return new Promise((resolve, reject) => {
			this.gltfLoader.load(path, resolve, progress, reject);

			function progress() { }
		});
	}

	/**
	 * Loads a model from a loaded / parse input file, returning an awaitable promise
	 * Uses 'any' for the Function types due to types given in library
	 * */
	loadModelFromArrayBuffer(buffer: string) {
		return new Promise((resolve, reject) => {
			this.gltfLoader.parse(buffer, '', resolve, reject);
		});
	}

	/**
	 * Loads a texture, returning an awaitable promise
	 * Uses 'any' for the Function types due to types given in library
	 * */
	loadTexture(path: string) {
		return new Promise((resolve, reject) => {
			this.textureLoader.load(path, resolve, progress, reject);

			function progress() { }
		});
	}
}
